import type { Reducer, Effect } from 'umi';
import { io, Socket } from 'socket.io-client';

export type StateType = {
  socket?: Socket;
};

export type SocketModelType = {
  namespace: string;
  state: StateType;
  effects: {
    init: Effect;
  };
  reducers: {
    setState: Reducer<StateType>;
  };
};

const SocketIO: SocketModelType = {
  namespace: 'socketIO',
  state: {
    socket: undefined,
  },

  effects: {
    *init({ payload }, { call, put, select }): Generator<any, void, any> {
      const _socket = yield select((state: any) => state.socketIO.socket);
      if (_socket) return;
      const socket = io(`${HTTP_PROTOCOL}://${SOCKET_URL}`!);
      // const socket = io("https://xiaohongshu.rasingsnail.com");
      // const socket = io("http://192.168.8.237:3001");
      yield put({
        type: 'setState',
        payload: { socket }
      })
    },
  },

  reducers: {
    setState(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
  },
};

export default SocketIO;
